import { useState, type ReactNode } from "react";

export interface TabDef {
  key: string;
  label: ReactNode;
  count?: number;
}

export function Tabs({
  tabs,
  initial,
  children,
  onChange,
}: {
  tabs: TabDef[];
  initial?: string;
  children: (activeKey: string) => ReactNode;
  onChange?: (key: string) => void;
}) {
  const [active, setActive] = useState(initial ?? tabs[0]?.key ?? "");
  return (
    <div>
      <div className="flex border-b border-border" role="tablist">
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              role="tab"
              aria-selected={isActive}
              onClick={() => {
                setActive(t.key);
                onChange?.(t.key);
              }}
              className={`px-4 py-2.5 text-sm font-medium -mb-px border-b-2 transition-colors ${
                isActive
                  ? "border-brand-500 text-fg"
                  : "border-transparent text-fg-subtle hover:text-fg"
              }`}
            >
              {t.label}
              {t.count !== undefined && (
                <span className="ml-1.5 text-xs text-muted font-mono">
                  ({t.count})
                </span>
              )}
            </button>
          );
        })}
      </div>
      <div className="pt-4">{children(active)}</div>
    </div>
  );
}
